import { generatePath, useRouteMatch } from 'react-router'
import { useFlags } from 'launchdarkly-react-client-sdk'

import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import {
  hideLeftPanel,
  selectLeftPanelVisibility,
  showLeftPanel,
} from 'common/components/leftPanel/store/leftPanelSlice'
import SubNavBar, { SubNavItem } from 'common/components/navigation/subNavBar'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { SidebarLeftMenu as SidebarLeftMenuIcon } from 'common/icons'

import { DASHBOARD_NAV_ITEMS, PATH } from '../interfaces'

const DashboardHeader = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const dispatch = useAppDispatch()
  const flags = useFlags()
  const isDashboardPathMatch = useRouteMatch([
    PATH.MetabaseAccount,
    PATH.MetabaseCampaign,
    PATH.DataSearch,
    PATH.JaqiAi,
  ])
  const leftPanelVisibility = useAppSelector(selectLeftPanelVisibility)

  const visibleNavItems = DASHBOARD_NAV_ITEMS.filter(({ key, flag }) => {
    if (key === 'data-search' || key === 'jaqi') {
      return flags.showReportingV1 && flags[flag]
    }
    return flags[flag]
  })

  return (
    <SubNavBar
      preTitle={
        isDashboardPathMatch &&
        flags.showSavedReports && (
          <ButtonWithTooltip
            tooltip
            tooltipText={
              leftPanelVisibility === 'hidden' || leftPanelVisibility === 'auto'
                ? 'Show panel'
                : 'Hide panel'
            }
            prefixIcon={<SidebarLeftMenuIcon isDefaultColor={false} size={5} />}
            onClick={() => {
              leftPanelVisibility === 'hidden'
                ? dispatch(showLeftPanel())
                : dispatch(hideLeftPanel())
            }}
          />
        )
      }
      title={isDashboardPathMatch && <span>Reports</span>}
    >
      {visibleNavItems.map(({ key, title, path }) => {
        const siblingPaths: Record<string, string> = {
          account: PATH.MetabaseAccountPersonalise,
          campaign: PATH.MetabaseCampaignPersonalise,
        }
        const sibling = siblingPaths[key]
        return (
          <SubNavItem
            key={key}
            title={title}
            to={generatePath(path, { accountId })}
            activePaths={
              sibling ? [generatePath(sibling, { accountId })] : undefined
            }
          />
        )
      })}
    </SubNavBar>
  )
}

export default DashboardHeader
